import React, { useState, useEffect, useMemo } from 'react'
import Autocomplete from '@mui/material/Autocomplete';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Grid, Divider,
  Box, Checkbox, Stack, Typography, IconButton, Button, Pagination,
  InputLabel, TextField, ListItemText, MenuItem, OutlinedInput, Select,
  FormControl, Chip, FormControlLabel, Tooltip, Card, Paper, Collapse, Link,
  RadioGroup,
  Radio
} from '@mui/material'
import AddIcon from "@mui/icons-material/Add";
import { useTheme } from '@mui/material/styles'
import _, { set } from 'lodash'
import { gmbCategories } from '../../../common/gmbCategory';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux'
import { getNumeric, promptOutputDnd, reviewProcessDnd, getUserId, convertArrayToDictionary, normalizeReasoningEffort } from '../../../common/utils';
import { fetchprompts, promptsSelector, setSelectedPromptData } from "../../../store/slices/prompts";
import { locationsSelector } from '../../../store/slices/location'
import { fetchGPTUsageData, setInput } from "../../../store/slices/logs";
import { generateTopics, getTopicsData, getStandardTopicsData, topicsSelector, executePromptMul, setPreGeneratedTopics, errorRemove } from "../../../store/slices/topics";
import Output from './outPut'
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import InputAdornment from "@mui/material/InputAdornment";
import AddPrompt from '../common/reviewComponents/addPrompt';
import TuneIcon from "@mui/icons-material/Tune";
import PromptSettings from '../common/promptSettings';
import ErrorModel from '../modals/errorModel';
import EditPrompts from '../modals/EditPrompts';
import moment from 'moment';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { companiesSelector } from '../../../store/slices/company';
import Topics from '../common/topics';
import CompanyTopics from '../../pages/topics/companyTopics';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useNavigate } from 'react-router';

const btypeMenus = _.map(gmbCategories, it => {
  return { label: it, value: it }
});
const GenerateTopics = ({ companyId, isInitialTopics, type,companyCompanyId, userRoles }) => {
  const [openAddPrompt, setOpenAddPrompt] = useState(false)
  const itemsPerPage = 50;
  const [selectedPrompt, setSelectedPrompt] = useState({})
  const [isExcecuteParrell, setisExcecuteParrell] = useState(true);
  const { prompts } = useSelector(locationsSelector);
  const { topics, companyTopics } = useSelector(topicsSelector)
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null)
  const [llm, setLlm] = useState("gpt-4");
  const [verbosity, setVerbosity] = useState("medium");
  const [reasoning_effort, setReasoningEffort] = useState("medium");
  const [temperature, setTemperature] = useState(0);
  const [inputFactor, setInputFactor] = useState(40);
  const [jsonResponse, setJsonResponse] = useState(false);
  const [responseApi, setResponseApi] = useState(false);
  const [api, setApi] = useState("completions");
  const [businessType, setBusinessType] = useState(btypeMenus[0]?.value);
  const [maxLength, setMaxLength] = useState(500);
  const [presencePenalty, setPresencePenalty] = useState(0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [noOfPages, setPages] = useState(0);
  const [reviewsPage, setReviewsPage] = React.useState(1);
  const [promptName, setPromptName] = useState('');
  const [promptType, setPromptType] = useState('');
  const [promptId, setPromptId] = useState('');
  const [searchCategory, setSearchCategory] = React.useState(null);
  // console.log('searchCategory', searchCategory)
  const [openEditPromptsModal, setEditPromptsModal] = useState(false)
  const [checked, setChecked] = useState([]);
  const [initialPromptType, setInitialPromptType] = useState(null);
  const [initialPrompt, setInitialPrompt] = useState(null);
  const [finalPromptType, setFinalPromptType] = useState(null);
  const [addedValues, setAddedValues] = useState([]);
  const [outputView, setOutputView] = useState(3);
  const [reviewProcess, setReviewProcess] = useState(50);
  const [isGenerated, setIsGenerated] = useState(false);
  const [businessTypeMenu, setBusinessTypeMenu] = useState('standard');
  const {companies} = useSelector(companiesSelector)
  const [topicsCompany, setTopicsCompany] = useState(null);


  const isIRUser = React.useMemo(() => userRoles?.indexOf("IRUser") >= 0, [userRoles]);
   const companyList = useMemo(()=>{ return _.sortBy(companies, 'name')},[companies])
  
  //=======Slider Menu=======//
  const handleSliderMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSliderMenuClose = () => {
    setAnchorEl(null);
  };
  const businessTypeMenus = React.useMemo(() => btypeMenus, [companyId])
  const openSliderMenu = Boolean(anchorEl);
  ////====End============////
  const globalReviews = [];
  const handleOpenAddPrompt = () => {
    setOpenAddPrompt(true)
  }
  const handleCloseAddPrompt = () => {
    setOpenAddPrompt(false)
  }
  const handleCloseError = () => {
    dispatch(errorRemove(topicKey))
  }
  useEffect(() => {
    setSearchCategory(searchCategory)
  }, [searchCategory])
  // useEffect(() => {
  //   dispatch(fetchprompts(companyId))
  // }, [companyId])
  const onSetBusinessType = (value) => {
    setBusinessType(value)
  }
  // useEffect(() => {
  //   if (companyId && !isInitialTopics) {
  //     dispatch(getTopicsData(companyId))
  //   }
  // }, [companyId, isInitialTopics])
  useEffect(() => {
    setBusinessType(btypeMenus[0]?.value)
  }, [btypeMenus])

  useEffect(()=>{
    
    if(businessTypeMenu==="company"){
      setTopicsCompany(companyList?.[0]?.companyId)

    }
  },[companies, businessTypeMenu, companyId]);
  
  const companyDic = useMemo(()=>convertArrayToDictionary(companies, 'companyId'),[companies])
  useEffect(()=>{
    
    if(businessTypeMenu==='standard'){
      setBusinessType(btypeMenus[0]?.value)
    }else if(businessTypeMenu==='company'){
      setBusinessType(companyDic?.[topicsCompany]?.businessType)
    }
  },[businessTypeMenu, topicsCompany]);  
  
  useEffect(() => {
    if (businessType && isInitialTopics) {
      dispatch(getStandardTopicsData(businessType))
    }
  }, [businessType, isInitialTopics])

  const uuidv4 = () => {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }
  const mergeOutPut = (topicsOutput) => {
    let isJson = false;

    let str = "";
    const arr = _.filter(_.map(topicsOutput, (it) => {
      let jObject = {};
      try {
        const splitArr = _.split(it, ',');
        const arr = _.filter(splitArr, it => {
          return it !== '\n}'
        })
        const val = _.join(arr, ',') + (arr.length !== splitArr.length ? '\n}' : '')
        jObject = JSON.parse(val);
        isJson = true;
      } catch (e) {
        str += it + "\n"; // error in the above string (in this case, yes)!
      }
      // let obj = typeof (it) === 'string' ? it : JSON.parse(it)
      // if (typeof (obj) !== 'string') {
      //     isJson = true
      // }
      return jObject;
    }), it => { return _.size(it) > 0 });
    // setShowCombineJson(isJson);
    return isJson ? arr : str;
  };
  const combindMultipleObjects = (data) => {

    let res = {};
    _.map(data, it => {
      if (it) {
        const splitArr = _.split(it, ',');
        const arr = _.filter(splitArr, it => {
          return it !== '\n}'
        })
        const val = _.join(arr, ',') + (arr.length !== splitArr.length ? '\n}' : '')
        let jObject = {};
        try {
          jObject = JSON.parse(val);
        } catch (e) {
          jObject = {} // error in the above string (in this case, yes)!
        }
        _.map(Object.keys(jObject), item => {
          res[item] = _.uniq(_.filter(_.concat(res[item], jObject[item]), obj => { return obj }));
        })
      }

    })
    return _.size(res) > 0 ? res : '';
  }
  const bindTopics = () => {
    let topicArray = _.orderBy(companyTopics ?? [], ['sequence']);
    let groupedData = _.groupBy(topicArray, 'parentTopicId');
    let parents = _.filter(topicArray, { parentTopicId: null });
    let dbArray = _.orderBy(_.map(parents, item => {
      return {
        name: item.name,
        topicId: item.topicId,
        id: item.topicId,
        parentTopicId: null,
        parentId: null,
        type: 0,
        sequence: item.sequence,
        data: _.map(groupedData[item.topicId], it => {
          return {
            name: it.name, insideDB: true,
            topicId: it.topicId,
            parentTopicId: item.topicId,
            id: it.topicId,
            parentId: item.topicId,
            sequence: it.sequence,
            type: 0,
          }
        }),
        insideDB: true,
      }
    }), ['sequence']);
    const topicsArr = combindMultipleObjects(topics[companyId])
    if (_.size(topicsArr) > 0) {
      const sequence = _.maxBy(dbArray, 'sequence')?.sequence + 1;
      const dbRows = _.groupBy(_.cloneDeep(dbArray), 'name');

      const latestTopics = _.map(Object.keys(topicsArr), (item, i) => {
        return {
          name: item,

          sequence: sequence + i,
          data: _.map(topicsArr?.[item], (it, j) => { return { name: it, insideDB: false, sequence: j + 1, } }),
          insideDB: false,
        }
      })
      dbArray = _.concat(dbArray, latestTopics);

      const fetchRows = _.groupBy(_.filter(_.cloneDeep(dbArray), { insideDB: false }), 'name');

      dbArray = _.map(_.groupBy(dbArray, 'name'), (items, key) => {
        const isAdded = !dbRows[key];
        const isDeleted = _.filter(items, { insideDB: true })?.length > 0 && !fetchRows[key];
        const type = isAdded ? 1 : isDeleted ? 2 : 0;
        const subTopics = _.flatMapDeep(_.map(items, 'data'));
        const dbTopicId = dbRows[key]?.[0]?.topicId
        const topicId = isAdded ? uuidv4() : dbTopicId;
        const sequence = isAdded ? items[0]?.sequence : dbRows[key]?.[0]?.sequence;

        return {
          color: type == 1 ? 'green' : (type == 2 ? 'red' : 'auto'),
          type: type,
          name: key,
          sequence: sequence,
          topicId: dbTopicId ?? null,
          parentTopicId: null,
          id: topicId,
          parentId: null,
          companyId: companyId,
          data: _.map(_.uniqBy(subTopics, 'name'), it => {

            const dbSubCategories = _.map(dbRows[key]?.[0]?.data, 'name') ?? [];
            const subCategories = _.map(fetchRows[key]?.[0]?.data, 'name') ?? [];

            const isAdded = !_.includes(dbSubCategories, it.name);
            const isDeleted = _.includes(dbSubCategories, it.name) && !_.includes(subCategories, it.name);
            const type = isAdded ? 1 : isDeleted ? 2 : 0;
            const dbId = _.find(dbRows[key]?.[0]?.data, { name: it.name })?.topicId
            const id = isAdded ? uuidv4() : dbId;
            return {
              ...it,
              color: type == 1 ? 'green' : (type == 2 ? 'red' : 'auto'),
              type: type,
              companyId: companyId,
              topicId: dbId ?? null,
              parentTopicId: dbTopicId ?? null,
              id: id,
              parentId: topicId,
            }
          })
        }
      });
    }
    let arrList = [];
    _.map(dbArray, item => {
      arrList = _.concat(arrList, [item]);
      arrList = _.concat(arrList, item.data);
      return arrList;
    });
    return arrList;
  }
  const finalData = (data) => {
    let topicArray = _.orderBy(data ?? [], ['sequence']);
    let groupedData = _.groupBy(topicArray, 'parentId');
    let parents = _.filter(topicArray, { parentId: null });
    let list = _.orderBy(_.map(parents, item => {
      return {
        ...item,
        data: _.map(groupedData[item.id], it => {
          return it;
        }),
      }
    }), ['sequence']);
    return list;
  }

  const topicsData = React.useMemo(() => bindTopics(), [companyTopics, topics]);
  const [collapseState, setCollapseState] = useState(false)
  const data = React.useMemo(() => finalData(addedValues), [addedValues]);
  // const topicsGroupedData = React.useMemo(() => _.groupBy(topicsData, 'name'), [topicsData]);
  const googleReviews = React.useMemo(() => _.filter(globalReviews, it => { return _.size(it.reviewText) > 10 }) ?? [], [globalReviews]);

  const filterdData = React.useMemo(() => { return (googleReviews.slice((reviewsPage - 1) * itemsPerPage, reviewsPage * itemsPerPage)) }, [googleReviews, itemsPerPage, reviewsPage])

  const settingsPromptsMemo = React.useMemo(() => prompts && prompts.length > 0 ? _.orderBy(_.filter(prompts, { type: type, subType: 'Topics' }), 'type', 'asc') : [], [prompts])
  const finalPromptDropdown = React.useMemo(() => _.concat([{ promptId: null, name: '', promptText: '', type: null }], _.filter(settingsPromptsMemo, it => {
    return it?.type === type && it.subType=== 'Topics'
  })), [settingsPromptsMemo])
  // const initialPrompt = React.useMemo(() => _.find(settingsPromptsMemo, { promptId: initialPromptType })?.promptText, [initialPromptType])
  const initial = React.useMemo(() => _.find(settingsPromptsMemo, { promptId: initialPromptType }), [initialPromptType])
  const finalPrompt = React.useMemo(() => _.find(finalPromptDropdown, { promptId: finalPromptType })?.promptText, [finalPromptType])
  const topicKey = React.useMemo(() => isInitialTopics ? (initialPromptType + '_' + businessType) : companyId, [initialPromptType, businessType]);

  const topicsOutputObj = React.useMemo(() => mergeOutPut(topics[topicKey]?.output), [topics[topicKey]]);
  const combineOutObj = React.useMemo(() => combindMultipleObjects(topics[topicKey]?.output), [topics[topicKey]]);
  const output = React.useMemo(() => outputView === 2 ? combineOutObj : topicsOutputObj, [topicsOutputObj, combineOutObj, outputView, businessType]);
  // const isInitialTopics = React.useMemo(() => true
  //   //initial?.type === 'BusinessSpecificTopics'
  //   , [initial]);
  const userId = React.useMemo(() => getUserId(), [localStorage.getItem('userId')]);

  useEffect(() => {
    dispatch(setPreGeneratedTopics(userId));
  }, [userId])

  useEffect(()=>{
    dispatch(getTopicsData(topicsCompany));
  },[topicsCompany])

  useEffect(() => {
    if (topicsData?.length > 0 && companyId) {

      setAddedValues(topicsData);
    }
  }, [topicsData]);

  useEffect(() => {
    if (initial) {
      const dParametersObj = JSON.parse(initial?.defaultParameters);
      setInitialPrompt(initial?.promptText);
      setSelectedPrompt(initial)
      setVerbosity(dParametersObj?.verbosity);
      setReasoningEffort(normalizeReasoningEffort(initial?.llm, dParametersObj?.reasoning_effort));
      setTemperature(dParametersObj?.temperature);
      setMaxLength(dParametersObj?.maxLength);
      setFrequencyPenalty(dParametersObj?.frequencyPenalty);
      setPresencePenalty(dParametersObj?.presencePenalty);
      setInputFactor(dParametersObj?.inputFactor);
      setJsonResponse(dParametersObj?.jsonResponse);
      setLlm(initial?.llm);
    }
    // setInitialPrompt(_.find(settingsPromptsMemo, { promptId: initialPromptType })?.promptText)
  }, [initialPromptType, initial])

  useEffect(() => {
    setPages(Math.ceil(googleReviews?.length / itemsPerPage));
  }, [googleReviews]);

  useEffect(() => {
    if (settingsPromptsMemo) {
      const companyCheck = _.find(settingsPromptsMemo, it => it.promptId === localStorage.getItem('topicsPrompt'))
      let processdPrompt = _.filter(settingsPromptsMemo, (item)=>item?.isProcessPrompt===true && item?.companyId==="00000000-0000-0000-0000-000000000000")
      if (isInitialTopics) {
        setInitialPromptType(companyCheck ? localStorage.getItem('topicsPromptInitial') : processdPrompt?processdPrompt?.[0]?.promptId:settingsPromptsMemo?.[0]?.promptId);
      }
      else {

        setInitialPromptType(companyCheck ? localStorage.getItem('topicsPrompt') : processdPrompt ? processdPrompt?.[0]?.promptId : settingsPromptsMemo?.[0]?.promptId);
      }
    }

  }, [settingsPromptsMemo]);

  // useEffect(() => {
  //   if (initialPromptType) {
  //     let filterPromptTypes = _.filter(_.cloneDeep(settingsPromptsMemo), it => { return it.promptId !== initialPromptType })
  //     let finalPrompt = !finalPromptType || initialPromptType === finalPromptType ? filterPromptTypes[0] : finalPromptType;
  //     setFinalPromptType(finalPrompt?.promptId);
  //   }
  // }, [initialPromptType])

  // useEffect(() => {

  //   let rawPrompt = prompt ? prompt + '\n' : '';
  //   _.map(_.filter(googleReviews, it => { return _.includes(checked, it.reviewId) }), (ob, i) => {
  //     rawPrompt += (i + 1) + '. ' + ob.reviewText + '\n';
  //   });
  //   setFullPrompt(rawPrompt);
  // }, [prompt, checked])

  //=====Close Modal====//
  const handleCloseAddLocationsModal = (event, reason) => {
    if (reason && reason == "backdropClick" && "escapeKeyDown")
      return;
    // setOpen(false)
    setChecked([])

  }
  const handleIntialPromptTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    setInitialPromptType(
      value
    );
    if (isInitialTopics) {
      localStorage.setItem('topicsPromptInitial', value)
    }
    else {

      localStorage.setItem('topicsPrompt', value)
    }
  };
  const outputViewOnChange = (event) => {
    const {
      target: { value },
    } = event;
    setOutputView(
      value
    );
  };
  const reviewProcessOnChange = (event) => {
    const {
      target: { value },
    } = event;
    setReviewProcess(
      value
    );
  };
  const onChangeParellelExcecute = (event) => {
    const {
      target: { checked },
    } = event;
    setisExcecuteParrell(
      checked
    );
  };

  const handleFinalPromptTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    setFinalPromptType(
      value
    );
  };
  const handleReviewSelect = (reviewId) => {
    if (checked) {
      if (checked.find((item) => item === reviewId)) {
        setChecked((checked) => checked.filter((item) => item !== reviewId));

      }
      else {
        setChecked([...checked, reviewId])

      }
    }
    else {
      setChecked([...checked, reviewId])

    };
  }
  const checkedAll = (isChecked) => {
    if (isChecked) {
      let checkedValues = _.cloneDeep(checked);
      checkedValues = _.uniq(_.concat(checkedValues, _.map(filterdData, 'reviewId')))
      setChecked(checkedValues)
    }
    else {
      let checkedValues = _.cloneDeep(checked);
      setChecked(_.filter(checkedValues, it => { return !_.includes(_.map(filterdData, 'reviewId'), it) }))
    }

  }

  useEffect(() => {
    if (settingsPromptsMemo.length > 0) {
      setPromptName(settingsPromptsMemo[0]?.name)
      setPromptType(settingsPromptsMemo[0]?.type)
      setPromptId(settingsPromptsMemo[0]?.promptId)
    }
    else {
      setPromptName("")
      setPromptType("")
      setPromptId("")
    }
  }, [settingsPromptsMemo])
  useEffect(() => {
    let input = isInitialTopics ? { ['BusinessType']: businessType, } : null
    if (companyId) {
      dispatch(setInput(input))
    }
  }, [businessType]);
  const onGenerateInitialTopics = () => {
    const replacePrompts = _.replace(initialPrompt, new RegExp('%BusinessType%', "ig"), businessType)

    const PromptInput = {
      prompt: {
        Prompt: replacePrompts,
        temperature: parseFloat(temperature),
        maxLength: parseInt(maxLength),
        isContainsMaxInput: false,
        llm: llm,
        inputFactor: inputFactor,
        jsonResponse: jsonResponse,
        presencePenalty: parseFloat(presencePenalty ?? 0),
        frequencyPenalty: parseFloat(frequencyPenalty ?? 0),
        companyId: initialPrompt?.companyId,
      },
      // CompanyId: companyId,
      data: [],
      key: topicKey,
      businessType: businessType,
      userId: getUserId(),
      Parallel: true,
      ProcessSingleReview: false,
    };
    let ExtraData = {
      PromptId: promptId,
      PromptName: promptName,
      PromptType: promptType,
      businessType: businessType
    }
    dispatch(executePromptMul({ PromptInput, ExtraData, businessType }, topicKey, getUserId(), companyId));
    setIsGenerated(true);
  }
  //===Generate Topics==//
  const onGenerateTopics = (e) => {
    if (isInitialTopics) {
      if (companyId)
        onGenerateInitialTopics();
    }
    else {
      const isString = typeof (reviewProcess) === 'string' ? true : false;
      const reviewToProcessText = _.find(reviewProcessDnd, { value: reviewProcess })?.label
      const data = {
        ReviewCount: isString ? 0 : (reviewProcess == 1 ? 0 : reviewProcess), MaxReviewDate: isString ? reviewProcess : null, CompanyId: companyId,
        PromptId: initialPromptType, FinalPromptId: finalPromptType, Parallel: isExcecuteParrell,
        ReviewToProcess: reviewToProcessText,
        key: companyId,
      };
      let ExtraData = {
        PromptId: data.PromptId,
      };
      dispatch(generateTopics({ topicInput: data, ExtraData }, data.key, companyId));
    }

  };
  const onSaveTopics = (e) => {
    let obj = { AddTopics: [], AddSubTopics: [], Modify: [], Delete: [], CompanyId: companyId }
    let cloneAddedValues = _.cloneDeep(addedValues);
    let savedData = _.filter(cloneAddedValues, it => { return it.type == 1 });

    let topicIds = _.map(cloneAddedValues, 'topicId');

    const deletedData = _.filter(_.cloneDeep(topicsData), item => { return (item.type == 0 || item.type == 2) && !_.includes(topicIds, item.topicId) });

    const newTopics = _.filter(savedData, { topicId: null, parentTopicId: null });
    const groupedByNewTopics = _.groupBy(newTopics, 'parentId');

    obj.AddTopics = _.map(_.filter(newTopics, { parentId: null }), item => {
      return {
        Topic: item.name,
        SubTopics: _.map(groupedByNewTopics[item.id], 'name')
      }
    });
    obj.AddSubTopics = _.map(_.filter(savedData, it => { return !it.topicId && it.parentTopicId }), item => {
      return {
        Id: item.parentTopicId,
        Name: item.name
      }
    });
    obj.Modify = _.map(_.filter(savedData, it => { return it.topicId && it.parentTopicId }), item => {
      return {
        Id: item.topicId,
        Name: item.name
      }
    });
    obj.Delete = _.map(deletedData, 'topicId');

    if ((savedData?.length > 0 || deletedData?.length > 0) && companyId) {
      // dispatch(saveTopics(obj, companyId));
    }

  };
  const onRestTopics = (e) => {
    let cloneAddedValues = _.cloneDeep(topicsData);
    setAddedValues(cloneAddedValues);

  };
  const handleClick = () => {
    console.info('You clicked the Chip.');
  };

  const handleDelete = (id, isParent) => {
    const values = _.filter(_.cloneDeep(addedValues), it => { return it.id !== id && (!isParent || it.parentId !== id) });
    setAddedValues(values);

  };

  const navigate = useNavigate();
  const handleEditPrompt = (selectedPrompt) => {
      dispatch(setSelectedPromptData(selectedPrompt))
      navigate('/prompts');
  }
    
  const outPutDnd = () => {
    return (
      <>
        <FormControl>
          <InputLabel>Display</InputLabel>
          <Select
            labelId="demo-output-view-label"
            id="demo-output-view"
            value={outputView ? outputView : ''}
            onChange={outputViewOnChange}
            input={<OutlinedInput
              sx={{
                height: '40px',
                padding: '10px 10px 10px 10px',
                width: '200px'
              }}
              label="Display" />}
            // inputProps={}

            size='small'
            MenuProps={{
              slotProps: {
                backdrop:
                {
                  sx:
                  {
                    backgroundColor: 'transparent',
                  }
                }
              },
              PaperProps: {
                sx: {

                  pb: 0,
                  border: `1px solid  ${theme.palette.divider}`,
                  boxShadow: theme.shadows[16],

                },
              }
            }}

          >
            {promptOutputDnd?.map((it) => (
              <MenuItem key={it.value} value={it.value}  >
                <ListItemText primary={it.label} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {outputView !== 3 &&
          <Stack direction={'row'} sx={{ width: '80px', justifyContent: 'flex-end' }}>
            <InputAdornment
              position="end"
            // sx={{ position: "absolute", marginTop: '20px', right: 20 }}
            >
              <Tooltip title="Copy to Clipboard" arrow>
                <IconButton
                  aria-label="Copy to clipboard"
                  onClick={() => {
                    navigator.clipboard.writeText(output ? JSON.stringify(output) : '');
                  }}
                >
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          </Stack>
        }
      </>

    )
  }
  const reviewProcessSection = () => {
    return (
      // <Box>
      // <InputLabel sx={{ width: '30%' }}><Typography variant="subtitle1">{'Reviews to process:'}:</Typography></InputLabel>
      <FormControl sx={{ mr: 1, mt: 2, width: "100%" }} size="small">
        <InputLabel>Reviews to process</InputLabel>
        <Select
          labelId="demo-review-process-label"
          id="demo-review-process"
          value={reviewProcess ? reviewProcess : ''}
          onChange={reviewProcessOnChange}
          input={<OutlinedInput
            sx={{
              height: '40px',
              padding: '10px 10px 10px 10px',
              // width: '200px'
            }}
            label="Reviews to process" />}
          // inputProps={}

          size='small'
          MenuProps={{
            slotProps: {
              backdrop:
              {
                sx:
                {
                  backgroundColor: 'transparent',
                }
              }
            },
            PaperProps: {
              sx: {

                pb: 0,
                border: `1px solid  ${theme.palette.divider}`,
                boxShadow: theme.shadows[16],
                height: '200px', overflow: 'auto'

              },
            }
          }}

        >
          {reviewProcessDnd?.map((it) => (
            <MenuItem key={it.value} value={it.value}  >
              <ListItemText primary={<Box>
                <Box>{it.label}</Box>
                {it.isSeparater && <hr style={{ marginTop: 5, marginBottom: 5 }} />}
              </Box>} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      // </Box>
    )
  }
  const theme = useTheme()
  
  return (
    <Box>
      <Stack direction={"row"} justifyContent={"space-between"}>
        {/* <Typography variant="h4">{"Generate Topics"}</Typography> */}
        {/* <IconButton onClick={handleCloseAddLocationsModal} sx={{ position: 'absolute', top: '13px', right: '15px' }}>
          <CloseIcon />
        </IconButton> */}
      </Stack>

      {/* <Divider /> */}
      <div
        style={{
          // border: "1px solid #ccc",
          // boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          marginTop: "15px",
          padding: "16px",
          height: 'calc(100vh - 226px)'
        }}>
        <Grid container columns={8} spacing={2}>
          <Grid item xs={4} sx={{ height: '100%' }}>

            <Stack spacing={2} alignItems={"center"}>
              <Stack direction='row' spacing={1} sx={{ width: '100%' }}>
                <FormControl
                  sx={{ width: "100%" }}
                  size='small'
                >
                  <InputLabel id="demo-multiple-checkbox-label">
                    {(isInitialTopics ? '' : 'Initial ') + "Prompt"}
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    value={initialPromptType ? initialPromptType : ""}
                    onChange={handleIntialPromptTypeChange}
                    input={<OutlinedInput label={(isInitialTopics ? '' : 'Initial ') + "Prompt"} />}
                    size='small'
                    MenuProps={{
                      slotProps: {
                        backdrop: {
                          sx: { backgroundColor: "transparent" },
                        },
                      },
                      PaperProps: {
                        sx: {
                         
                          border: `1px solid  ${theme.palette.divider}`,
                          boxShadow: theme.shadows[16],
                        },
                      },
                    }}
                  >
                    {settingsPromptsMemo?.map((prompt) => (
                      // <MenuItem key={it.promptId} value={it.promptId}
                      //   onClick={() => {
                      //     setPromptId(it.promptId);
                      //     setPromptType(it.type);
                      //     setPromptName(it.name);
                      //     setSelectedPrompt(it)
                      //   }}
                      // >
                      //   {it.name}
                      // </MenuItem>
                      <MenuItem
                      sx={{ display: "flex", justifyContent: "space-between" }}
                      key={prompt.name}
                      value={prompt.promptId}
                      onClick={() => {
                        setPromptId(prompt?.promptId);
                        setPromptType(prompt?.type);
                        setPromptName(prompt?.name);
                        // const promptObj = { name: prompt?.name, promptId: prompt?.promptId, type: prompt?.type }
                        // localStorage.setItem(settingsPromptsMemo ? 'topicsPrompt' : isInitialTopics ? 'topicsPromptInitial' : '', JSON.stringify(promptObj))
                      }}
                    >
                     
                      <ListItemText

                        primary={
                          <Stack
                            direction="row"
                            sx={{ width: "100%", mr: 3.5, height:'23px' }}
                            spacing={0}
                            justifyContent={"space-between"}
                            alignItems={"baseline"}
                          >
                             <Stack direction={'row'} spacing={2} alignItems={'center'}>
                            <Typography>
                              {prompt.name}
                            </Typography>
                           {prompt?.version&&<Typography color="text.disabled">
                              {"(v"+prompt?.version+")"} 
                            </Typography>}
                            </Stack>
                            <Stack direction={'row'} spacing={2} alignItems={'center'}>
                           
                              <Typography color="text.disabled">

                               {prompt.llm}
                              </Typography>
                              <Tooltip disableInteractive arrow title={prompt?.createdOn && prompt?.modifiedOn ? <Stack spacing={.5}>
                                <div>Created by: {prompt?.createdBy}</div>
                                <div>Created on: {moment(prompt?.createdOn).format('MMMM Do YYYY, h:mm:ss a')}</div>
                                <div>Modified by: {prompt?.modifiedBy}</div>
                                <div>Modified on: {moment(prompt?.modifiedOn).format('MMMM Do YYYY, h:mm:ss a')}</div>
                              </Stack> : ''}>
                                <span>
                                  <PersonOutlineOutlinedIcon fontSize="small" sx={{ color: theme => theme.palette.text.disabled }} />
                                </span>
                              </Tooltip>

                            </Stack>
                          </Stack>
                        }
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis", m:0
                        }}
                      />
                      {/* <IconButton
              onClick={() => handleOpenWarning(prompt?.promptId)}
            >
              <DeleteIcon fontSize="small" />
            </IconButton> */}
                    </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {isInitialTopics && <IconButton sx={{ ml: 1, visibility: 'hidden' }} onClick={handleOpenAddPrompt}>
                  <AddIcon />
                </IconButton>}
              </Stack>
            {isInitialTopics&&isIRUser && <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight:'48px' }}>
                <RadioGroup
                  name='businessTypeRadio'
                  row
                  value={businessTypeMenu}
                  onChange={(e)=>setBusinessTypeMenu(e.target.value)}
                  sx={{flexWrap:'nowrap'}}
                >
                   <FormControlLabel
                     value={'standard'}
                     name='standard'
                     control={<Radio  />}
                     label="Standard"
                   />
                   <FormControlLabel
                     value={'company'}
                     name='company'
                     control={<Radio  />}
                     label="Company"
                   />
                   
                </RadioGroup>
                <Select 
                     size='small'
                     sx={{minWidth:'150px', width:'calc(100% - 126px)'}}
                     disabled={businessTypeMenu!=='company'}
                     value ={topicsCompany}
                     onChange={(e)=>setTopicsCompany(e.target.value)}
                     
                   >
                      {_.map(companyList, it=><MenuItem key={it.companyId} value={it.companyId}>{it.name}</MenuItem>)}
                   </Select>
              </Box>}
              {isInitialTopics &&
                <Stack direction={'row'} spacing={1} sx={{ width: '100%' }}>
                  <FormControl
                    sx={{ width: "100%" }}
                    size='small'
                    fullWidth
                  >
                    {/* <InputLabel id="demo-multiple-checkbox-label">
                    {"Business Type"}
                  </InputLabel> */}
                    <Autocomplete
                      className='333'
                      // sx={{ height: '30px' }}
                      disableClearable
                      labelId="demo-multiple-checkbox-label"
                      id={'value'}
                      // inputValue={searchCategory}
                      value={businessType}
                      // onChange={(e) => onSetBusinessType}
                      onChange={(event, newInputValue) => {
                        onSetBusinessType(newInputValue.value)
                        // setSearchCategory(newInputValue);
                      }}
                      onInputChange={(event, newInputValue) => {
                        onSetBusinessType(newInputValue)
                        // setSearchCategory(newInputValue);
                      }}
                      sx={{ pt: '0 !important', }}
                      renderInput={(params) => <TextField
                        {...params}
                        InputProps={{
                          ...params.InputProps,
                          type: 'search',
                          sx: { height: '40px', pt: '0 !important', pb: '0 !important' }
                        }}
                        label="Business Type" />}
                      options={businessTypeMenus}
                      MenuProps={{
                        slotProps: {
                          backdrop: {
                            sx: { backgroundColor: "transparent" },
                          },
                        },
                        PaperProps: {
                          sx: {
                            pb: 0,
                            pt: 0,
                            // height: '42px',
                            border: `1px solid  ${theme.palette.divider}`,
                            boxShadow: theme.shadows[16],
                          },
                        },
                      }}
                    >
                      {/* {_.map(businessTypeMenus, it => {
                      return (<MenuItem value={it.value}>
                        {it.label}
                      </MenuItem>)
                    })} */}
                    </Autocomplete>
                  </FormControl>
                  <Tooltip title="Add Prompt">
                    <IconButton sx={{ ml: 1 }} onClick={handleOpenAddPrompt}>
                      <AddIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
              }

            </Stack>
            <Collapse in={collapseState}>
              {/* <Stack direction={'row'} spacing={3} alignItems={'center'}>
                <InputLabel sx={{ mt: 1 }}>
                  <Typography variant="subtitle1">
                    {(isInitialTopics ? '' : 'Initial ')}Prompt Text:
                  </Typography>

                </InputLabel>
                <Link onClick={() => setEditPromptsModal(true)} sx={{ fontSize: '14px', display: 'flex', cursor: 'pointer' }}><BorderColorIcon fontSize='14px' sx={{ mt: 0.3 }} />Edit</Link>
              </Stack> */}
              <TextField
                inputProps={{
                  style: {
                    height: isInitialTopics ? "calc(100vh - " + (450) + "px)" : "calc(100vh - 300px)",
                    // overflowY: 'scroll',
                    paddingRight: "10px",
                    // padding: '0 14px',
                  },
                }}
                multiline
                rows={1}
                style={{ width: "100%", margin: "0" }}
                type="text"
                placeholder="Enter Prompt.."
                variant="outlined"
                value={initialPrompt}
                onChange={(e) => {
                  setInitialPrompt(e.target.value);
                }}
                disabled={!isInitialTopics}
              />
            </Collapse>
            <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 2 }}>
              {type !== 'Topics' && <Link sx={{ cursor: 'pointer' }} onClick={() => setCollapseState(prev => !prev)}>{collapseState ? 'Less' : 'More'} Info</Link>}
              <Link sx={{ cursor: 'pointer', width: 'fit-content', display: 'flex', alignItems: 'center' }} onClick={() => handleEditPrompt(selectedPrompt)}><EditOutlinedIcon sx={{ mr: 0.5, fontSize: '16px' }} />Edit Prompt</Link>
            </Stack>
            {!isInitialTopics && (
              <Grid container columns={1} spacing={2}>
                <Grid item xs={1}>
                  {reviewProcessSection()}
                </Grid>
                <Grid item xs={1}>
                  <FormControl
                    sx={{ mb: 2, mr: 1, mt: 2, width: "100%" }}
                    size="small"
                  >
                    <InputLabel
                      sx={{ mt: 0 }}
                      id="demo-multiple-checkbox-label"
                    >
                      {"Final Prompt"}
                    </InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      // disabled={true}
                      id="demo-multiple-checkbox"
                      // value={finalPromptType ? finalPromptType : ''}
                      value={finalPromptType}
                      onChange={handleFinalPromptTypeChange}
                      input={<OutlinedInput label="Prompt Type" />}
                      size="small"
                      MenuProps={{
                        slotProps: {
                          backdrop: {
                            sx: { backgroundColor: "transparent" },
                          },
                        },
                        PaperProps: {
                          sx: {
                            pb: 0,
                            border: `1px solid  ${theme.palette.divider}`,
                            boxShadow: theme.shadows[16],
                          },
                        },
                      }}
                    >
                      {finalPromptDropdown?.map((it) => (
                        <MenuItem key={it.promptId} value={it.promptId}>
                          <ListItemText
                            sx={{ minHeight: "26px" }}
                            primary={it.type ? it.type + " - " + it.name : null}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <InputLabel>
                    <Typography variant="subtitle1">
                      Final Prompt Text:
                    </Typography>
                  </InputLabel>
                  <TextField
                    inputProps={{
                      style: {
                        height: "calc(50vh - 300px)",
                        // overflowY: 'scroll',
                        paddingRight: "10px",
                        // padding: '0 14px',
                      },
                    }}
                    multiline
                    rows={1}
                    style={{ width: "100%", margin: "0" }}
                    type="text"
                    placeholder="Enter Prompt.."
                    variant="outlined"
                    value={finalPrompt}
                    disabled
                  // onChange={(e) => { setPrompt(e.target.value) }}
                  />
                </Grid>
              </Grid>
            )}

            <Stack
              direction={"row"}
              spacing={2}
              alignItems={"center"}
              justifyContent={"space-between"}
              pt={2}
            >
              <Button
                disabled={
                  _.size(initialPrompt) === 0 && _.size(finalPrompt) === 0
                }
                color="primary"
                variant="contained"
                ml={1}
                pt={{ mt: (theme) => theme.spacing(2) }}
                onClick={(e) => {
                  onGenerateTopics(e);
                  e.stopPropagation();
                }}
                sx={{ textTransform: "none" }}
                size="small"
              >
                Generate
              </Button>
              {isInitialTopics &&
                <Tooltip title="Settings">
                  <IconButton
                    sx={{ height: "fit-content" }}
                    onClick={handleSliderMenuOpen}
                  >
                    <TuneIcon />
                  </IconButton>
                </Tooltip>
              }
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack spacing={1}>
              { <Output
                businessType={businessType}
                isInitialTopics={isInitialTopics}
                output={output}
                topics={topics}
                topicKey={topicKey}
                outputView={outputView}
                outPutDnd={outPutDnd}
                companyId={companyId}
                isGenerated={isGenerated}
                companyCompanyId={companyCompanyId}
                
              />}
             {/* {isIRUser && <CompanyTopics
                companyId={topicsCompany}
                companyTopics={companyTopics}
                
              />} */}
            </Stack>
          </Grid>
        </Grid>
      </div>
      {openAddPrompt && (
        <AddPrompt
          open={openAddPrompt}
          handleClose={handleCloseAddPrompt}
          selectedCompany={companyId}
          type={type}
        />
      )}
      {topics[topicKey]?.errorMessage && (
        <ErrorModel
          open={topics[topicKey]?.errorMessage}
          onClose={handleCloseError}
          errorMessage={topics[topicKey]?.errorMessage}
          selectedCompany={companyId}
          type={type}
        />
      )}
      <PromptSettings openSliderMenu={openSliderMenu} handleSliderMenuClose={handleSliderMenuClose} anchorEl={anchorEl}
        params={{
          llm, setLlm, presencePenalty, setPresencePenalty,verbosity,
          setVerbosity,
          reasoning_effort,
          setReasoningEffort,
          temperature, setTemperature,
          frequencyPenalty, setFrequencyPenalty, maxLength, setMaxLength,
          inputFactor, setInputFactor, jsonResponse, setJsonResponse, responseApi, setResponseApi, api, setApi
        }} />
      {openEditPromptsModal && selectedPrompt?.promptId && <EditPrompts open={openEditPromptsModal} handleClose={() => setEditPromptsModal(false)} selectedPrompt={selectedPrompt} companyId={companyId} />}
    </Box>
  );
}

export default GenerateTopics
